/**
 * 1 September of the current school year: this year's if we are already in
 * September or later, otherwise last year's.
 *
 * Reports are normally run over the summer, so in practice this usually lands
 * on the previous calendar year.
 */
export const lastSeptember = (today: Date = new Date()): Date => {
  const september = 8; // Date months are zero-based
  const year = today.getMonth() >= september ? today.getFullYear() : today.getFullYear() - 1;
  return new Date(year, september, 1);
};
